import React, { FunctionComponent } from "react";
import { Box, Button } from "@mui/material";

import { CheckIcon } from "assets";

interface StatusChangeButtonsProps {
  isCreateMode: boolean;
  isAdditionalStatusesOn: boolean;
  isNotApplicableInvalidDataButtonDisabled: boolean;
  isNotApplicableCostOnlyButtonDisabled: boolean;
  onSetStatus: (status: string) => void;
}

export const StatusChangeButtons: FunctionComponent<StatusChangeButtonsProps> = ({
  isCreateMode,
  isAdditionalStatusesOn,
  isNotApplicableInvalidDataButtonDisabled,
  isNotApplicableCostOnlyButtonDisabled,
  onSetStatus,
}) => {
  if (isCreateMode || !isAdditionalStatusesOn) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Button
        sx={{
          height: "fit-content",
        }}
        variant="outlined"
        startIcon={<CheckIcon />}
        disabled={isNotApplicableInvalidDataButtonDisabled}
        onClick={() => onSetStatus("Not Applicable (Invalid Data)")}
      >
        Not Applicable (Invalid Data)
      </Button>
      <Button
        sx={{
          height: "fit-content",
        }}
        variant="outlined"
        startIcon={<CheckIcon />}
        disabled={isNotApplicableCostOnlyButtonDisabled}
        onClick={() => onSetStatus("Not Applicable (Cost Only)")}
      >
        Not Applicable (Cost Only)
      </Button>
    </Box>
  );
};

